import { useMutation, useQueryClient } from "@tanstack/react-query";
import OnlineOrderValuesModel from "../../../models/formModels/onlineOrderValues.model";
import { useOktaAuth } from "@okta/okta-react";
import { useHistory, useLocation } from "react-router-dom";
import toastMessages from "../../helpers/toastMessage";
import OnlineOrderActions from "../../../OnlineOrderActions";
import { useContext } from "react";
import { PopUpContext } from "../../../context/popupContext";
import useProfile from "../useProfile";
import { ApplicationState } from "../../../context/ApplicationStateContext";

function useCreateOrder() {
 const data = useOktaAuth();
 const authState = data?.authState;
 const queryClient = useQueryClient();
 const { setVisible } = useContext(PopUpContext);
 const history = useHistory();
 const location = useLocation();
 const profile = useProfile();
const {
  state: { selectedPhysicianData },
} = useContext(ApplicationState);

 return useMutation({
  mutationKey: ["createOrder"],
  mutationFn: (data: OnlineOrderValuesModel) => {
  const { patientName, ...restData } = data;
  const { testTypeId, ...patientInfoWithoutTestTypeId } = restData.patientInfo || {};
    let cleanedData = {
    ...restData,
    patientInfo: patientInfoWithoutTestTypeId,
    isPotentialDuplicateOrder: restData.isPotentialDuplicateOrder ?? false,
  };
   // Use duplicated patient id when order was started after "duplicate patient" flow
   const duplicatePatientId = sessionStorage.getItem("orderDuplicatePatientId");
   if (duplicatePatientId) {
    cleanedData = { ...cleanedData, patientId: duplicatePatientId };
    sessionStorage.removeItem("orderDuplicatePatientId");
   } else {
    const locationState = location.state as { patientInformation?: string } | undefined;
    if (locationState?.patientInformation) {
     try {
      const parsed = JSON.parse(locationState.patientInformation);
      if (parsed?.id) {
       cleanedData = { ...cleanedData, patientId: parsed.id };
      }
     } catch {
      // ignore parse errors
     }
    }
   }
   const orderActions = new OnlineOrderActions(
    Number(data.organizationId),
    Number(data.physicianId),
    selectedPhysicianData,
    profile?.data?.user?.roles ?? [],
    profile?.data?.user?.id ?? ""
   );
   return orderActions.createOrder({
    data: cleanedData,
    token: authState?.accessToken?.accessToken ?? "",
   });
  },
  onSuccess: (res) => {
   queryClient.invalidateQueries({ queryKey: ["testsList"] });
   setVisible(false);
   if (res?.data?.data?.isSave === "true") {
    history.push("/access/test-orders");
    toastMessages.success("Order created successfully");
   } else {
    history.push(
     `/access/online-order/order-created?id=${res?.data?.data?.id}`
    );
   }
  },
  onError: (error: any) => {
   const errorMessage =
    error?.response?.data?.message ?? error.message ?? "Failed to update order";
   toastMessages.error(errorMessage);
  },
 });
}

export default useCreateOrder;
